/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConfigurationStatus = {
    Ok: 'ok',
    NeedsReconfiguration: 'needs_reconfiguration'
} as const;
export type ConfigurationStatus = typeof ConfigurationStatus[keyof typeof ConfigurationStatus];

